import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import { Dispatch } from '@reduxjs/toolkit';
import { AppDispatch } from '../../reducers/store';
import { PaginationItem } from '@mui/material';
import { ApiParams } from '../../api';

import './pagination.css'

interface PaginationParams{
    id?: string
    page?: any;
    actionGet: (params: ApiParams) => (dispatch: Dispatch) => Promise<any>; 
    numberOfPages?: number
    totalNumber?: number
}

const Paginate = ({ id, page, actionGet, numberOfPages, totalNumber }: PaginationParams) => {
  const dispatch = useDispatch<AppDispatch>()
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (page && actionGet) {
      dispatch(actionGet({ id, page }));
    }
  }, [page, actionGet, id, dispatch]);

  const constructUrlWithPage = (page: any) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('page', page);
    return `${pathname}?${searchParams.toString()}`;
  };

  return (
    <div className="main-pagination">
      <Stack spacing={2}>
        <Pagination 
          count={numberOfPages}
          variant="outlined"
          shape="rounded"
          color='primary'
          page={Number(page) || 1}
          renderItem={(item) => (
            <PaginationItem { ...item } component={Link} to={constructUrlWithPage(item.page)} />
          )}
        />
        <span>{totalNumber} results found</span>
      </Stack>
    </div>
  );
}

export default Paginate